import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { CursorStyle } from "../../foundations/cursor-style.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
const iconButtonStyleOverrides = {
  root: {
    padding: Spacing["500"],
    "& .MuiSvgIcon-root": {
      fontSize: "inherit"
    },
    [`&.${MuiClassCollection.disabled}`]: {
      pointerEvents: "initial",
      cursor: CursorStyle.notAllowed
    }
  },
  sizeSmall: {
    fontSize: Spacing["1000"]
  },
  sizeMedium: {
    fontSize: Spacing["1500"]
  },
  sizeLarge: {
    fontSize: Spacing["2000"]
  }
};
export {
  iconButtonStyleOverrides
};
//# sourceMappingURL=styles.es.js.map
